import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../component/Header";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

import api from "../../Services/api";
import { useSwal } from "../../component/sweetalert";

export default function AddEvents() {
  const { id } = useParams();
  const navigate = useNavigate();
  const alert = useSwal();
  const quillRef = useRef();
const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    link: "",
    event_date: "",
    starttime: "",
    endtime: "",
    ModeOfMeeting: "",
    venue: "",
    refreshments_time_start: "",
    refreshments_time_end: "",
    contents: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [existingImage, setExistingImage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/webp"];
      if (!validTypes.includes(file.type)) {
        alert("error", "Only JPG, PNG, and WEBP files are allowed.");
        return;
      }
      setSelectedFile(file);
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const data = new FormData();
  Object.entries(formData).forEach(([key, val]) => data.append(key, val));
  if (selectedFile) {
    data.append("file", selectedFile);
  }

  try {
     setLoading(true);
    let response;

    if (id) {
      // Edit mode
      response = await api.post(`/EditEvent/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        alert("success", "Event updated successfully!");
        navigate("/events");
      } else {
        alert("error", response.data.message || "Failed to update event.");
      }
    } else {
      // Add mode
      response = await api.post("/insertEvent", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 201) {
        alert("success", "Event added successfully!");
        e.target.reset();
        setFormData({
          title: "",
          link: "",
          event_date: "",
          starttime: "",
          endtime: "",
          ModeOfMeeting: "",
          venue: "",
          refreshments_time_start: "",
          refreshments_time_end: "",
          contents: "",
        });
        setSelectedFile(null);
        navigate("/events");
      } else {
        alert("error", response.data.message || "Failed to add event.");
         setLoading(false);
      }
    }
  } catch (error) {
    console.error("❌ Submit error:", error);
    alert("error", "Something went wrong while submitting the form.");     
  }finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const res = await api.post(`/getEventById/${id}`);
          const event = res.data || {};
          setFormData({
            title: event.title || "",
            link: event.link || "",
            event_date: event.event_date || "",
            starttime: event.starttime || "",
            endtime: event.endtime || "",
            ModeOfMeeting: event.ModeOfMeeting || "",
            venue: event.venue || "",
            refreshments_time_start: event.refreshments_time_start || "",
            refreshments_time_end: event.refreshments_time_end || "",
            contents: event.contents || "",
          });
          setExistingImage(event.photo ? `/uploads/event/${event.photo}` : "");
        } catch (err) {
          alert("error", "Failed to load event details.");
        }
      })();
    }
  }, [id, alert]);

  return (
    <section className="dashboardpage">
      <Header pageTitle={id ? "Edit Event" : "Add Events Details"} backTo="/events" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-start col-xl-6 col-12">
          <form className="form-fields d-flex" onSubmit={handleSubmit}>
            <div className="grid-container">
              {/* Title */}
              <div className="input-container">
                <input
                  type="text"
                  name="title"
                  placeholder="Enter Event Title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                />
                <span className="underline"></span>
              </div>

              {/* Meeting Mode */}
              <div className="radio-container">
                <span className="radio-label">Select Mode of Meeting</span>
                <div className="radio-container button">
                  {["Online Meeting", "Offline Meeting"].map((mode) => (
                    <label
                      key={mode}
                      className={`radio-option ${formData.ModeOfMeeting === mode ? "active" : ""}`}
                    >
                      <input
                        type="radio"
                        name="ModeOfMeeting"
                        value={mode}
                        checked={formData.ModeOfMeeting === mode}
                        onChange={handleChange}
                        required
                      />{" "}
                      {mode}
                    </label>
                  ))}
                </div>
              </div>

              {/* Date */}
              <div className="input-container">
                <input
                  type="date"
                  name="event_date"
                  value={formData.event_date}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="date">Enter Event Date</label>
                <span className="underline"></span>
              </div>

              {/* Online Link */}
              {formData.ModeOfMeeting === "Online Meeting" && (
                <div className="input-container">
                  <input
                    type="text"
                    name="link"
                    placeholder="Enter Meeting Link"
                    value={formData.link}
                    onChange={handleChange}
                    required
                  />
                  <span className="underline"></span>
                </div>
              )}

              {/* Offline Fields */}
              {formData.ModeOfMeeting === "Offline Meeting" && (
                <>
                  <div className="input-container">
                    <input
                      type="text"
                      name="venue"
                      placeholder="Enter Venue"
                      value={formData.venue}
                      onChange={handleChange}
                      required
                    />
                    <span className="underline"></span>
                  </div>
                  <div className="refreshmentsTimeStart">
                    <div className="input-container">
                      <input
                        type="time"
                        name="refreshments_time_start"
                        value={formData.refreshments_time_start}
                        onChange={handleChange}
                      />
                      <label>Refreshments Start Time</label>
                      <span className="underline"></span>
                    </div>
                    <div className="input-container">
                      <input
                        type="time"
                        name="refreshments_time_end"
                        value={formData.refreshments_time_end}
                        onChange={handleChange}
                      />
                      <label>Refreshments End Time</label>
                      <span className="underline"></span>
                    </div>
                  </div>
                </>
              )}

              {/* Image */}
              <div className="input-container file-input-container">
                <input type="file" onChange={handleFileChange} accept=".jpg,.jpeg,.png,.webp" />
                {selectedFile ? (
                  <p className="file-name">{selectedFile.name}</p>
                ) : existingImage ? (
                  <p className="file-name">{existingImage.split("/").pop()}</p>
                ) : (
                  <p>No image uploaded</p>
                )}
                <span className="underline"></span>
              </div>

              {/* Time Inputs */}
              <div className="Eventstarttime">
                <div className="input-container">
                  <input
                    type="time"
                    name="starttime"
                    value={formData.starttime}
                    onChange={handleChange}
                    required
                  />
                  <label>Enter Event Start Time</label>
                  <span className="underline"></span>
                </div>

                <div className="input-container">
                  <input
                    type="time"
                    name="endtime"
                    value={formData.endtime}
                    onChange={handleChange}
                    required
                  />
                  <label>Enter Event End Time</label>
                  <span className="underline"></span>
                </div>
              </div>

              {/* Description */}
              <div className="input-container description-container">
                <ReactQuill
                  ref={quillRef}
                  value={formData.contents}
                  onChange={(val) => setFormData((prev) => ({ ...prev, contents: val }))}
                  theme="snow"
                  placeholder="Description"
                  className="react-quill-wrapper"
                />
              </div>

              <button className="btn btn-purpal" type="submit" disabled={loading}>
                {id ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
